/**
 * A list of the all of the possible provider for the assets
 * @module services/assets/providers
 */
import _replace from 'lodash/replace'
import path from 'path'

export const ASSETS_PROVIDER_AWS_S3 = 'AWS_S3'

/**
 * The base files path in S3
 * @type {String}
 */
export const ASSETS_PROVIDER_AWS_S3_BASE_PATH = 'assets'

/**
 * Create an key for the providers file system e.g. in AWS S3 this would be the filename
 * @param {String} uuid The uuid of the asset
 * @param {String} originalFileName The the asset's original file name
 * @param {String} folderPath A path where the assets will be placed under the basePath
 * @param {String} basePath A basePath for the key on the providers file system
 * @returns {String} The key which maps to the assets on the provider
 */
export function createProviderKey (uuid, originalFileName, folderPath = '', basePath = ASSETS_PROVIDER_AWS_S3_BASE_PATH) {
  const extname = _replace(path.extname(originalFileName), /^\./, '')
  const fullPath = folderPath ? `${basePath}/${folderPath}` : basePath
  return `${fullPath}/${uuid}.${extname}`
}

export function getAllProviders () {
  return [ASSETS_PROVIDER_AWS_S3]
}
